import React, { useState, useEffect, useContext } from "react";
import { Navigate } from "react-router-dom";
import "../../../App.css";
import Navbar from "../../ui/Navbar";
import Table from "../../ui/Table";
import Loader from "../../ui/Loader";
import { AuthContext } from "../../../context/AuthContext";
import { swalError } from "../../../utils/swalAlert";
import { fetchWithAuth } from "../../../utils/api";

const serverUrl = `${process.env.REACT_APP_SERVER_URL}`;

export default function InstituteStats() {
  const [statsData, setStatsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showSubscribedOnly, setShowSubscribedOnly] = useState(true);

  const { isAuthenticated, primaryRole } = useContext(AuthContext);

  const breadcrumbs = [
    { name: "Home", path: "/superadmin", isLast: false },
    { name: "Institute Stats", path: "/superadmin/stats", isLast: true },
  ];

  // Fetch stats from API
  const fetchStats = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(
        `${serverUrl}/api/institute/get-stats?hasSubscribed=${showSubscribedOnly}`,
        {
          credentials: "include",
        },
      );
      if (!response) return;
      if (!response.ok) throw new Error("Failed to fetch institute stats");
      const result = await response.json();
      setStatsData(result.data || []);
      setError(null);
    } catch (err) {
      setError(err.message);
      swalError(err.message || "Failed to load institute stats.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSubscribedOnly]);

  const columns = [
    { key: "name", label: "Institute Name", sortable: true },
    { key: "code", label: "Code", sortable: true },
    { key: "instructors", label: "Instructors", sortable: true },
    { key: "students", label: "Students", sortable: true },
    { key: "classes", label: "Classes", sortable: true },
    { key: "tests", label: "Tests", sortable: true },
    { key: "completedGradings", label: "Completed Gradings", sortable: true },
  ];

  document.title = "GradeMe-AI: Institute Stats";

  if (!isAuthenticated || primaryRole !== "superadmin") {
    return <Navigate to="/login" replace />;
  }

  if (error) {
    return <div className="error-div">{error}</div>;
  }

  return (
    <div className="super-admin-container">
      <Navbar pageName="Institute Stats" breadcrumbs={breadcrumbs} />
      <div className="top-actions">
        <div className="filters-group">
          <label className="filter-toggle">
            <span className="toggle-label">
              {showSubscribedOnly
                ? "Subscribed Institutes Only"
                : "All Institutes"}
            </span>
            <input
              type="checkbox"
              checked={showSubscribedOnly}
              onChange={() => setShowSubscribedOnly(!showSubscribedOnly)}
            />
            <span className="toggle-track">
              <span className="toggle-indicator"></span>
            </span>
          </label>
        </div>
      </div>
      <div className="table-section">
        {loading ? (
          <Loader style={{ fontSize: "2.2rem" }} />
        ) : (
          <Table
            data={statsData}
            columns={columns}
            caption={"Institute Statistics"}
          />
        )}
      </div>
    </div>
  );
}
